import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTopMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronTopMedium"><Path d="M19.4141 14.5L18 15.9141L12 9.91406L6 15.9141L4.58594 14.5L12 7.08594L19.4141 14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTopMedium;
